import React from 'react'
import { IInputProps } from 'src/types'
import BasicArrayInput from './BasicArrayInput'
import ObjectArrayInput from './ObjectArrayInput'

export default (props: IInputProps<any[]>): JSX.Element => {
  const { property } = props
  const items = property.items

  if (
    items !== undefined &&
    (typeof items?.$ref === 'string' ||
      ('type' in items && items.type === 'object'))
  ) {
    return <ObjectArrayInput {...props} />
  }

  // TODO: Improve surrounding types to fix
  // @ts-ignore
  return <BasicArrayInput {...props} />
}
